<template>
  <section class="promotions">
    <h1 class="promotions-section-title">Promociones</h1>
    <div class="columns is-mobile is-multiline">
      <div class="column is-full-mobile is-half-tablet is-one-third-desktop promo">
        <figure class="image">
          <img
            src="@/assets/promo.jpg"
            alt=""
            title="">
          <figcaption class="promo-info">
            <h3>Título de Ejemplo</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <a class="button is-primary btn-promo-details">
              <span class="icon">
                <information-outline-icon/>
              </span>
            <span>Ver detalles</span></a>
          </figcaption>
        </figure>
      </div>
      <div class="column is-full-mobile is-half-tablet is-one-third-desktop promo">
        <figure class="image">
          <img
            src="@/assets/promo2.jpg"
            alt=""
            title="">
          <figcaption class="promo-info">
            <h3>Título de Ejemplo</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <a class="button is-primary btn-promo-details">
              <span class="icon">
                <information-outline-icon/>
              </span>
            <span>Ver detalles</span></a>
          </figcaption>
        </figure>
      </div>
      <div class="column is-full-mobile is-half-tablet is-one-third-desktop promo">
        <figure class="image">
          <img
            src="@/assets/promo3.png"
            alt=""
            title="">
          <figcaption class="promo-info">
            <h3>Título de Ejemplo</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <a class="button is-primary btn-promo-details">
              <span class="icon">
                <information-outline-icon/>
              </span>
            <span>Ver detalles</span></a>
          </figcaption>
        </figure>
      </div>
      <div class="column is-full-mobile is-half-tablet is-one-third-desktop promo">
        <figure class="image">
          <img
            src="@/assets/promo4.jpg"
            alt=""
            title="">
          <figcaption class="promo-info">
            <h3>Título de Ejemplo</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <a class="button is-primary btn-promo-details">
              <span class="icon">
                <information-outline-icon/>
              </span>
            <span>Ver detalles</span></a>
          </figcaption>
        </figure>
      </div>
      <div class="column is-full-mobile is-half-tablet is-one-third-desktop promo">
        <figure class="image">
          <img
            src="@/assets/promo5.jpg"
            alt=""
            title="">
          <figcaption class="promo-info">
            <h3>Título de Ejemplo</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <a class="button is-primary btn-promo-details">
              <span class="icon">
                <information-outline-icon/>
              </span>
            <span>Ver detalles</span></a>
          </figcaption>
        </figure>
      </div>
      <div class="column is-full-mobile is-half-tablet is-one-third-desktop promo">
        <figure class="image">
          <img
            src="@/assets/promo6.jpg"
            alt=""
            title="">
          <figcaption class="promo-info">
            <h3>Título de Ejemplo</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <a class="button is-primary btn-promo-details">
              <span class="icon">
                <information-outline-icon/>
              </span>
            <span>Ver detalles</span></a>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';

export default {
  name: 'Promotions',
  components: {
    InformationOutlineIcon,
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";

.promotions {
  margin-bottom: 2rem;

  @include tablet {
    padding: 0 4%;
  }

  .promotions-section-title {
    color: lighten($dark-cyan-gray, 30);
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    padding-left: 4%;

    @include tablet {
      padding: 0;
    }

    @include from(1000px) {
      font-size: 1.5rem;
    }
  }

  .promo {
    margin-bottom: 2rem;
    @include tablet {
      margin-bottom: 1rem;
    }
  }

  .promo-info {
    padding: 1rem calc(4% + 0.75rem) 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include tablet {
      padding: 1rem 0 0 0;
    }

    h3{
      color: #fff;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 1rem;
      text-align: left;
      width: 100%;

      @media screen and (min-width: 540px) {
        font-size: 1.25rem;
      }
    }

    p {
      color: #fff;
    }

    .button {
      font-weight: bold;
      margin-top: 0.75rem;
      margin-bottom: 0;

      @include from(960px) {
        margin-top: 1.25rem;
      }

      @include from(500px) {
        font-size: 1rem;

        .icon {
          span {
            width: 90%;
            height: 90%;
          }
        }
      }
    }
  }
}
</style>
